import { inject, computed, provide } from "vue-demi";
const FORMS_CONFIG_KEY = Symbol("forms-config");
export function provideFormsConfig(config) {
  provide(FORMS_CONFIG_KEY, config);
}
export function useFormsConfig() {
  const config = inject(
    FORMS_CONFIG_KEY,
    computed(() => ({}))
  );
  const baseUrl = computed(() => config.value?.baseUrl || "");
  const locale = computed(() => config.value?.locale || "");
  return {
    baseUrl,
    recaptcha: config.value?.recaptcha,
    endpoints: config.value?.endpoints,
    locale,
    formsApi: config.value?.formsApi
  };
}
